import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/widget.css';
import '@/app/dev.css';
import { App } from '@/app/App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
